module.exports = __webpack_public_path__ + "media/applicants/help-icon-504f0d99.png";